
import { defineComponent } from 'vue';
export default defineComponent({
    /*フォームの入力項目*/
    name: 'InputItem',
    props: {
        title: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        errorMessage: {
            type: String,
            default: '',
        },
        availableMessage: {
            type: String,
            default: '',
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        isDarkGray: {
            type: Boolean,
            default: false,
        },
        isMultiple: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Number,
            default: 0,
        },
        isAbsolute: {
            type: Boolean,
            default: false,
        },
        isChangeFont: {
            type: Boolean,
            default: false,
        },
        isUserNameAvailable: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'icon-clicked', 'button-click'],
});
